import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { LeadFormActions } from '../../../../../Services/_actions';
import { leadDetailObjAtom } from '../../../../../Services/_states/LeadForm';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { interveneAiSummaryAtom } from '../../../state/interveneAtoms';

export default function AISummaryTab({ isDrawerOpen }) {
  const leadFormActions = LeadFormActions();
  const [leadDetails] = useRecoilState(leadDetailObjAtom);
  const [aiSummary, setAiSummary] = useRecoilState(interveneAiSummaryAtom);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   if (!isDrawerOpen || !leadDetails?.id) {
  //     setAiSummary(null);
  //     return;
  //   }

  //   let cancelled = false;
  //   const load = async () => {
  //     setIsLoading(true);
  //     try {
  //       const res = await leadFormActions.getAiChatDetail(leadDetails.id);
  //       if (!cancelled) {
  //         setAiSummary(res?.data || res || null);
  //       }
  //     } catch {
  //       if (!cancelled) setAiSummary(null);
  //     } finally {
  //       if (!cancelled) setIsLoading(false);
  //     }
  //   };
  //   load();

  //   return () => {
  //     cancelled = true;
  //   };
  // }, [isDrawerOpen, leadDetails?.id, leadFormActions, setAiSummary]);

  if (!leadDetails?.id) {
    return (
      <Typography variant="body2" color="text.secondary">
        Select a lead to view AI summary.
      </Typography>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!aiSummary) {
    return (
      <Typography variant="body2" color="text.secondary">
        No AI summary available for this lead yet.
      </Typography>
    );
  }

  const summaryText =
    aiSummary?.summary ||
    aiSummary?.call_summary ||
    aiSummary?.data?.summary ||
    (typeof aiSummary === 'string' ? aiSummary : null);

  const questions =
    aiSummary?.suggested_questions ||
    aiSummary?.questions ||
    aiSummary?.data?.suggested_questions ||
    [];

  const transcript =
    aiSummary?.transcript ||
    aiSummary?.data?.transcript ||
    [];

  return (
    <Box>
      {summaryText && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Previous Call Summary
          </Typography>
          <Typography variant="body2">{summaryText}</Typography>
        </Box>
      )}

      {Array.isArray(questions) && questions.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Suggested Questions
          </Typography>
          <Box component="ul" sx={{ pl: 2, m: 0 }}>
            {questions.map((q, i) => (
              <Typography component="li" variant="body2" key={i}>
                {typeof q === 'string' ? q : q?.text || q?.question}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {Array.isArray(transcript) && transcript.length > 0 && (
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Transcript
          </Typography>
          {transcript.map((item, i) => (
            <Box key={i} sx={{ mb: 1, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
              {item.sender && (
                <Typography variant="caption" color="text.secondary">
                  {item.sender}
                </Typography>
              )}
              <Typography variant="body2">{item.message || item.text || item.content}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {!summaryText && questions.length === 0 && transcript.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          AI data returned but no displayable content found.
        </Typography>
      )}
    </Box>
  );
}
